import { useState, useEffect } from 'react';

/**
 * HelpModal - Help button with tooltip on hover and modal on click
 */
export default function HelpModal() {
    const [isOpen, setIsOpen] = useState(false);

    // Close on ESC key
    useEffect(() => {
        const handleEsc = (e: KeyboardEvent) => {
            if (e.key === 'Escape') {
                setIsOpen(false);
            }
        };

        document.addEventListener('keydown', handleEsc);
        return () => document.removeEventListener('keydown', handleEsc);
    }, []);

    return (
        <>
            {/* Help Button */}
            <button
                id="helpButton"
                className="help-button"
                aria-label="Ajuda"
                onClick={() => setIsOpen(true)}
            >
                <img
                    src="/images/help-icon.webp"
                    alt="Ajuda"
                />
            </button>

            {/* Help Tooltip (CSS hover) */}
            <div className="help-tooltip">
                <p className="help-tooltip-text">
                    Clique para ver instruções detalhadas e exemplos de perguntas que você
                    pode fazer ao Oráculo.
                </p>
            </div>

            {/* Help Modal */}
            <div
                id="helpModal"
                className={`help-modal ${isOpen ? 'visible' : ''}`}
                onClick={(e) => {
                    if (e.target === e.currentTarget) {
                        setIsOpen(false);
                    }
                }}
            >
                <div className="help-modal-content">
                    <button
                        id="closeModal"
                        className="help-modal-close"
                        aria-label="Fechar"
                        onClick={() => setIsOpen(false)}
                    >
                        <i className="fas fa-times"></i>
                    </button>

                    <h2 className="help-modal-title">Como Consultar o Oráculo</h2>

                    <div className="help-modal-section">
                        <h3 className="help-modal-subtitle">
                            <i className="fas fa-scroll"></i>
                            Instruções
                        </h3>
                        <p className="help-modal-text">
                            O Oráculo é um guardião ancestral que percorre os arquivos
                            secretos da Ordem Inédita para revelar{' '}
                            <strong>QUAL aula ou pergaminho</strong> você deve assistir para
                            encontrar a resposta que busca.
                        </p>
                        <p className="help-modal-text">
                            <strong>O que o Oráculo faz:</strong>
                            <br />• Localiza as aulas exatas que respondem sua dúvida
                            <br />• Indica qual conteúdo assistir e em qual ordem
                            <br />• Conecta conhecimentos relacionados
                            <br />• Direciona para suporte humano quando necessário
                        </p>
                        <p className="help-modal-text">
                            <strong>O que o Oráculo NÃO faz:</strong>
                            <br />• Não ensina o conteúdo das aulas
                            <br />• Não resume estratégias ou técnicas
                            <br />• Não substitui assistir os pergaminhos sagrados
                        </p>
                    </div>

                    <div className="help-modal-section">
                        <h3 className="help-modal-subtitle">
                            <i className="fas fa-lightbulb"></i>
                            Exemplos de Perguntas
                        </h3>
                        <div className="help-examples">
                            <div className="help-example-item">
                                Como encontrar meu posicionamento único?
                            </div>
                            <div className="help-example-item">
                                Qual aula ensina a criar uma oferta irresistível?
                            </div>
                            <div className="help-example-item">
                                Como escrever uma VSL que converte?
                            </div>
                            <div className="help-example-item">
                                Onde aprender sobre estratégias de lançamento?
                            </div>
                            <div className="help-example-item">
                                Como criar anúncios que chamam atenção?
                            </div>
                            <div className="help-example-item">
                                Preciso criar meu primeiro infoproduto, por onde começo?
                            </div>
                            <div className="help-example-item">
                                Como construir uma audiência qualificada?
                            </div>
                        </div>
                    </div>

                    <div className="help-modal-section">
                        <h3 className="help-modal-subtitle">
                            <i className="fas fa-star"></i>
                            Dicas para Melhores Resultados
                        </h3>
                        <p className="help-modal-text">
                            <strong>Seja específico:</strong> Quanto mais clara sua dúvida,
                            mais precisa será a revelação do Oráculo.
                        </p>
                        <p className="help-modal-text">
                            <strong>Pergunte sobre TEMAS:</strong> O Oráculo te guia para ONDE
                            aprender, não ensina diretamente.
                        </p>
                        <p className="help-modal-text">
                            <strong>Respeite a jornada:</strong> O Oráculo pode indicar uma
                            sequência de aulas. Assistir os pergaminhos na ordem sugerida
                            maximiza seu aprendizado.
                        </p>
                        <p
                            className="help-modal-text"
                            style={{
                                fontStyle: 'italic',
                                marginTop: '1rem',
                                color: 'rgba(255,255,255,0.7)',
                            }}
                        >
                            O poder não está no mapa. Está na jornada. 🔮
                        </p>
                    </div>
                </div>
            </div>
        </>
    );
}
